import { useEffect, useRef } from 'react';
import { useTheme } from '../../contexts/theme.context';
import classes from './ktzh-backdrop.module.scss';

const KtzhBackdrop = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { theme } = useTheme();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const ctx = canvas.getContext('2d');
    if (!ctx) return undefined;

    const blobs = [
      { x: 0.25, y: 0.35, r: 300, p: 0, c: [28, 155, 215] as const },
      { x: 0.78, y: 0.4, r: 280, p: 2, c: [56, 182, 232] as const },
      { x: 0.55, y: 0.8, r: 260, p: 4, c: [189, 146, 48] as const },
    ];

    let frame = 0;
    let raf = 0;

    const draw = (t: number) => {
      const W = canvas.width;
      const H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      const light = theme !== 'dark';
      ctx.globalCompositeOperation = light ? 'multiply' : 'lighter';
      blobs.forEach((b) => {
        const x = b.x * W + Math.sin(t / 2600 + b.p) * 90;
        const y = b.y * H + Math.cos(t / 3000 + b.p) * 60;
        const g = ctx.createRadialGradient(x, y, 0, x, y, b.r);
        const a = light ? 0.1 : 0.16;
        g.addColorStop(0, `rgba(${b.c[0]},${b.c[1]},${b.c[2]},${a})`);
        g.addColorStop(1, `rgba(${b.c[0]},${b.c[1]},${b.c[2]},0)`);
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, W, H);
      });
      ctx.globalCompositeOperation = 'source-over';
      frame = requestAnimationFrame(draw);
    };

    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [theme]);

  return <canvas ref={canvasRef} className={classes.backdrop} width={1600} height={1000} aria-hidden />;
};

export default KtzhBackdrop;
